import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV;
const isLocal = APP_ENV === "local";
const isProd = APP_ENV === "prod";

export const env = createEnv({
  isServer: typeof window === "undefined",
  skipValidation: process.env.NODE_ENV === "test",
  server: {
    CMS_API_TOKEN: z.string(),
    SENDGRID_USER: isLocal ? z.string().optional() : z.string(),
    SENDGRID_PASSWORD: isLocal ? z.string().optional() : z.string(),
    REVALIDATE_SECRET_TOKEN: z.string().optional(),
    NODE_ENV: z.enum(["development", "test", "production"]),
    APP_ENV: z.enum(["local", "qa", "prod"]),
    DATABASE_URI: z.string(),
    DATABASE_SSL: z.preprocess((val) => val === "true", z.boolean()),
    DATABASE_PUSH: z.preprocess((val) => val === "true", z.boolean()),
    PAYLOAD_SECRET: z.string(),
    BAMBOO_API_KEY: isLocal ? z.string().optional() : z.string(),
    REDIS_HR_URL: isProd ? z.url() : z.url().optional(),
    STORAGE_S3_REGION: isLocal ? z.string().optional() : z.string(),
    STORAGE_S3_BUCKET: isLocal ? z.string().optional() : z.string(),
    PREVIEW_SECRET: isLocal ? z.string().optional() : z.string(),
    ASSETS_CDN_URL: isLocal ? z.string().optional() : z.string(),
  },
  runtimeEnv: {
    CMS_API_TOKEN: process.env.CMS_API_TOKEN,
    SENDGRID_USER: process.env.SENDGRID_USER,
    SENDGRID_PASSWORD: process.env.SENDGRID_PASSWORD,
    REVALIDATE_SECRET_TOKEN: process.env.REVALIDATE_SECRET_TOKEN,
    NODE_ENV: process.env.NODE_ENV,
    APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
    DATABASE_URI: process.env.DATABASE_URI,
    DATABASE_SSL: process.env.DATABASE_SSL,
    DATABASE_PUSH: process.env.DATABASE_PUSH,
    PAYLOAD_SECRET: process.env.PAYLOAD_SECRET,
    BAMBOO_API_KEY: process.env.BAMBOO_API_KEY,
    REDIS_HR_URL: process.env.REDIS_HR_URL,
    STORAGE_S3_ACCESS_KEY_ID: process.env.STORAGE_S3_ACCESS_KEY_ID,
    STORAGE_S3_SECRET_ACCESS_KEY: process.env.STORAGE_S3_SECRET_ACCESS_KEY,
    STORAGE_S3_REGION: process.env.STORAGE_S3_REGION,
    STORAGE_S3_BUCKET: process.env.STORAGE_S3_BUCKET,
    PREVIEW_SECRET: process.env.PREVIEW_SECRET,
    ASSETS_CDN_URL: process.env.ASSETS_CDN_URL,
  },
});
